import enLocale from 'mdesign-plus/lib/locale/lang/en';
import arLocale from 'mdesign-plus/lib/locale/lang/ar';
import thLocale from 'mdesign-plus/lib/locale/lang/th';
// site map locale
const i18nMap = {
    'en': {
        ...enLocale
    },
    'ar': {
        ...arLocale
    },
    'th': {
        ...thLocale
    },
};
export default i18nMap

export const useI18n = (site) => {
    return i18nMap[site] || i18nMap['en'];
}